import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { IconButton, InputAdornment, TextField, TextFieldProps } from '@mui/material';
import { ForwardedRef, forwardRef, useState } from 'react';

type PasswordInputProps = TextFieldProps & { testId?: string; 'data-testid'?: never };

export const PasswordInput = forwardRef(
  ({ testId, ...props }: PasswordInputProps, ref: ForwardedRef<HTMLDivElement | null>) => {
    const [show, setShow] = useState(false);

    const handleClickShowPassword = () => setShow((show) => !show);

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
    };

    const handleMouseUpPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
    };
    return (
      <TextField
        {...props}
        ref={ref}
        data-testid={testId}
        type={show ? 'text' : 'password'}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label={show ? 'hide the password' : 'display the password'}
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                onMouseUp={handleMouseUpPassword}
                data-testid={testId ? `${testId}_ToggleButton` : undefined}
                edge="end">
                {show ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    );
  },
);
